import { platformApiSlice } from "./platformApiSlice";

export const platformWebsitesApiSlice = platformApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWebsites: builder.query({
      query: ({ useProd = false, updateMetrics = false }) => ({
        url: `/api/v1/websites/`,
        params: {
          use_prod: useProd,
          update_metrics: updateMetrics,
        },
      }),
      providesTags: ["Websites"],
    }),
    getWebsitesList: builder.query({
      query: ({ useProd = false }) => ({
        url: `/api/v1/websites/list`,
        params: { use_prod: useProd },
      }),
      providesTags: ["Websites"],
    }),
    getWebsiteById: builder.query({
      query: ({ websiteId, useProd = false }) => ({
        url: `/api/v1/websites/${websiteId}`,
        params: { use_prod: useProd },
      }),
      providesTags: (result, error, { websiteId }) => [{ type: "Websites", id: websiteId }],
    }),
    createWebsite: builder.mutation({
      query: ({ website, useProd = false }) => ({
        url: "/api/v1/websites/",  // Trailing slash to avoid redirect
        method: "POST",
        body: website,
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Websites"],
    }),
    updateWebsite: builder.mutation({
      query: ({ websiteId, website, useProd = false }) => ({
        url: `/api/v1/websites/${websiteId}`,
        method: "PUT",
        body: website,
        params: { use_prod: useProd },
      }),
      invalidatesTags: (result, error, { websiteId }) => [{ type: "Websites", id: websiteId }, "Websites"],
    }),
    deleteWebsite: builder.mutation({
      query: ({ websiteId, useProd = false }) => ({
        url: `/api/v1/websites/${websiteId}`,
        method: "DELETE",
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Websites"],
    }),
    updateSubscriptionPlan: builder.mutation({
      query: ({ websiteId, subscriptionPlan }) => ({
        url: `/api/v1/websites/${websiteId}/subscription-plan`,
        method: "PATCH",
        body: { subscription_plan: subscriptionPlan },
        params: { use_prod: true },
      }),
      invalidatesTags: (result, error, { websiteId }) => [{ type: "Websites", id: websiteId }, "Websites"],
    }),
    getWebsitesByTiers: builder.query({
      query: ({ tiers }) => ({
        url: `/api/v1/websites/by-tiers`,
        method: "POST",
        body: { tiers },
        params: { use_prod: true },
      }),
      providesTags: ["Websites"],
    }),
    updateWebsiteUseFixedIp: builder.mutation({
      query: ({ websiteId, useFixedIp, useProd = false }) => ({
        url: `/api/v1/websites/${websiteId}/use-fixed-ip`,
        method: "PATCH",
        body: { use_fixed_ip: useFixedIp },
        params: { use_prod: useProd },
      }),
      invalidatesTags: (result, error, { websiteId }) => [{ type: "Websites", id: websiteId }, "Websites"],
    }),
    updateWebsiteUseWebBotAuth: builder.mutation({
      query: ({ websiteId, useWebBotAuth, useProd = false }) => ({
        url: `/api/v1/websites/${websiteId}/use-web-bot-auth`,
        method: "PATCH",
        body: { use_web_bot_auth: useWebBotAuth },
        params: { use_prod: useProd },
      }),
      invalidatesTags: (result, error, { websiteId }) => [{ type: "Websites", id: websiteId }, "Websites"],
    }),
  }),
});

export const {
  useGetWebsitesQuery,
  useGetWebsitesListQuery,
  useGetWebsiteByIdQuery,
  useGetWebsitesByTiersQuery,
  useUpdateSubscriptionPlanMutation,
  useCreateWebsiteMutation,
  useUpdateWebsiteMutation,
  useDeleteWebsiteMutation,
  useUpdateWebsiteUseFixedIpMutation,
  useUpdateWebsiteUseWebBotAuthMutation,
} = platformWebsitesApiSlice;
